module.exports = __webpack_public_path__ + "media/images/icons/facebook-e7066ad1036b226738df9e784afb4344.svg";